import {createContext} from 'react';

export const OverlayContainerContext = createContext<Element | null>(null);
OverlayContainerContext.displayName = 'OverlayContainerContext';
